// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import AlertCmp from '@/components/Alert.vue'
import ViteAutocomplete from '@/components/ViteAutocomplete'
import router from './router'
import { store } from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import {Logger, matchTargetNavigator} from '@/utils/tools'
import linkify from 'vue-linkify'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'
import {authMixin} from './router/functionalityAuth'
import { lang, i18n } from './i18n'
import zhHans from 'vuetify/lib/locale/zh-Hans'
import allHtmlConfig from '../config/htmlConfig'
import ModuleContainer from './components/ModuleContainer'
Vue.use(Vuetify, {
  lang: {
    locales: { zhHans },
    current: lang
  },
  theme: {
    primary: allHtmlConfig[process.env.NODE_ENV]?.primaryColor || '#224855',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})
Vue.directive('linkified', linkify)
Vue.config.productionTip = false

Vue.component('App', App)
Vue.component('app-alert', AlertCmp)
Vue.component('vite-autocomplete', ViteAutocomplete)
Vue.component('vite-module-container', ModuleContainer)
Vue.mixin(authMixin)
/* eslint-disable no-new */
// eslint-disable-next-line
var vm = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  beforeCreate () {
    matchTargetNavigator(i18n)
    firebase.initializeApp(process.env.firebaseConfig)
    if (process.env.isProduction) {
      firebase.firestore.setLogLevel('error')
    } else if (process.env.functionPort) {
      firebase.functions().useFunctionsEmulator(`http://localhost:${process.env.functionPort}`)
    }
    Logger.initialize(this.$store)
    this.$store.commit('setVersion', process.env.version)
    this.$store.commit('setEnvironment', process.env.NODE_ENV)
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        return this.$store.dispatch('initializeApp', user)
          .then(() => {
            return this.$store.dispatch('loadUser', user)
          })
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js